import axios from 'axios'
import Cookies from 'js-cookie'
import { API_KEY_LINX } from 'src/util/config'
import { RelatedProductResponse } from './dtos/related-products-response'
import { DeviceType } from 'src/contexto/types'

export const getRelatedProducts = async (
  source: DeviceType = DeviceType.DESKTOP,
  name: string,
  productId?: number,
  categoryName?: string
): Promise<RelatedProductResponse> => {
  const deviceId = Cookies.get('nav_id') ?? null

  const { data } = await axios.get<RelatedProductResponse>(
    `https://recs.chaordicsystems.com/v0/pages/recommendations?apiKey=${API_KEY_LINX}&name=${name}&source=${source}${
      deviceId ? `&deviceId=${deviceId}` : ''
    }${productId ? `&productId=${productId}` : ''}${
      categoryName ? `&categoryId=${categoryName}` : ''
    }&showOnlyAvailable=true&productFormat=complete`
  )

  return data
}
